import RsaPlanning from "../index.js"

const routes = [
  {
    name: "RsaPlanningAll",
    path: "/rsaplanning",
    component: RsaPlanning.RsaPlanningPage,
    meta: { title: "R.S.A. - Planning generale" },
  },
];

export default routes;
